import styled from "styled-components";

import { Body } from "@components/Typography";
import { useTheme } from "@hooks";
import { CSSProperties } from "react";

export const LinkWrapper = styled(Body)`
  font-weight: 500;
  cursor: pointer;
  -webkit-touch-callout: none;
  -webkit-user-select: none;
  -khtml-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
`;

export const useStyles = () => {
  const { theme } = useTheme();

  const styles: Record<string, CSSProperties> = {
    wrapper: {
      color: theme.link.default,
    },
  };

  return styles;
};
